// extracted by mini-css-extract-plugin
export var measureBox = "_redotech-redo-web-src-common-text-measure-box-measure-box";